import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../../_metronic/layout/core'
import { AdminAppBreadCrumbs } from '../core/_constants'
import AdminAppCard from '../components/AdminAppCard'
import AdminAppDataTable from '../components/AdminAppDataTable'
import { useLocation, useNavigate } from 'react-router-dom'
import ClassificationComparisionModal from '../components/ClassificationComparisionModal'

const AdminApp = () => {
    const { formatMessage } = useIntl()
    const [isActive, setIsActive] = useState(false)
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const query = searchParams.get('tabKey')
    // const tab = searchParams.get('tab')
    const navigate = useNavigate()
    const [tabKey, setTabKey] = useState(Number(query) || 1)

    const handleTabChange = (key: number, tabName: string) => {
        setTabKey(key)
        navigate(`?tab=${tabName}`, { replace: true })
    }
    return (
        <>
            <PageTitle
                breadcrumbs={AdminAppBreadCrumbs}
                description={formatMessage({ id: 'Admin App' })}
            >
                {formatMessage({ id: 'RecordsKeeper AI' })}
            </PageTitle>
            {/* button for desktop view */}
            <div
                className='d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block'
                style={{ top: '80px', right: '30px' }}>
                <div className='d-flex flex-column mt-3 top-btn-main'>
                    <div className='d-flex justify-content-end gap-4 align-items-center'>
                        <button
                            type='button'
                            className='btn bg-primary custom-button-property font-size-13 text-white font-weight-400 w-100 text-nowrap d-flex align-items-center justify-content-center height-36'
                            onClick={() => setIsActive(true)}
                        >
                            {formatMessage({ id: 'Start Classification' })}
                        </button>
                        <button
                            className='btn bg-primary custom-button-property font-size-13 text-white font-weight-400 w-100 text-nowrap d-flex align-items-center justify-content-center height-36'
                        >
                            {formatMessage({ id: 'Start Scoring' })}
                        </button>
                    </div>
                </div>
            </div>
            {/* button for mobile view */}
            <div className='d-flex align-items-center gap-2 gap-lg-3 d-block d-sm-none px-6'>
                <div className='d-flex flex-column mt-3 top-btn-main'>
                    <div className='d-flex flex-column align-items-center w-100 w-md-auto gap-2 mb-4 mb-md-auto'>
                        <button
                            type='button'
                            className='btn bg-primary font-size-13 text-white mb-md-4 mb-0 font-weight-400 w-100 custom-button-property '
                            onClick={() => setIsActive(true)}
                        >
                            {formatMessage({ id: 'Start Classification' })}
                        </button>
                        <button
                            type='button'
                            className='btn bg-primary font-size-13 text-white mb-md-4 mb-0 font-weight-400 w-100 custom-button-property '
                        >
                            {formatMessage({ id: 'Start Scoring' })}
                        </button>
                    </div>
                </div>
            </div>
            <ClassificationComparisionModal isActive={isActive} setIsActive={setIsActive} />
            <div className='px-6 mb-8'>
                <div className='d-flex h-55px border-bottom space-between w-100 justify-content-between prospective-investor-tab'>
                    <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5  flex-nowrap mobile-tab-both mb-0 '>
                        <li className='nav-item mobile-tab font-size-13'>
                            <div
                                className={`nav-link text-active-primary me-6 cursor-pointer ${tabKey === 1 ? 'active' : ''
                                    }`}
                                onClick={() => handleTabChange(1, 'india')}
                            >
                                {formatMessage({ id: 'India' })}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            {/* {tab && */}
            <>
                <div className='d-flex flex-md-row flex-column px-6 gap-4'>
                    <AdminAppCard stat='267' title='Total Files' comparer='' />
                    <AdminAppCard stat='25,678' title='Net Score' comparer='25%' />
                    <AdminAppCard stat='75' title='Average Score Per File' comparer='-25%' />
                    <AdminAppCard stat='1 m 23 s' title='Average Classification Time' comparer='-25%' />
                </div>
                <div className='px-6 my-4'>
                    <AdminAppDataTable />
                </div>
            </>
            {/* } */}
        </>
    )
}

export default AdminApp
